"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _size = require("../../hooks/size");
var _ThreadListLayout = _interopRequireDefault(require("../ThreadListLayout"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = function _default(_ref) {
  var isEmpty = _ref.isEmpty,
    cards = _ref.cards,
    header = _ref.header,
    fallback = _ref.fallback,
    actions = _ref.actions,
    children = _ref.children;
  var ref = (0, _react.useRef)(null);
  var containerRef = (0, _react.useRef)(null);
  var _useSize = (0, _size.useSize)(ref),
    height = _useSize.height;
  return /*#__PURE__*/_react["default"].createElement(_ThreadListLayout["default"], {
    isEmpty: isEmpty,
    header: header,
    fallback: fallback,
    actions: actions
  }, function (_ref2) {
    var setShadow = _ref2.setShadow;
    if (isEmpty) return null;
    var renderProps = {
      setShadow: setShadow,
      listRef: containerRef
    };
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: ref,
      className: "h-full"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      ref: containerRef,
      style: {
        height: height
      },
      id: "masonry-container",
      className: "relative overflow-y-auto"
    }, cards, typeof children === 'function' ? children(renderProps) : children));
  });
};
//# sourceMappingURL=index.js.map